module.exports = __webpack_public_path__ + "img/status.e0da814e.svg";